fragment AccountTypeAutomation on AccountTypeAutomation {
    id
    accountType {
        id
        name
    }
}
